import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import _ from "lodash";

import { CalculatorField } from "components/CalcComponents/CalculatorField";
import { MarkAdapter } from "../../../components/MarkAdapter";
import { CalcResult } from "./CalcResults";
import leftArrow from "assets/img/blue-arrow-left.png";
import closeBtn from "assets/img/x_icon.png";

const tripleCalcHref = window.location.href;
const subTripleCalcHref = "triple-calc";

export const CustomCalculator = ({
  labels, 
  chosenFields, 
  unchosenField, 
  parentHandleClickCalcAgain, 
  showCustomCalcOnMob, 
  formFields, 
  buildJsonAndCallLastScore,
  scoresData,
  handleChange,
  validate,
  checkIfInvalid,
  showResult,
}) => {
  const [checkBox, setCheckBox] = useState(false);

  const handleClickCalcAgain = () => {
    parentHandleClickCalcAgain();
  }

  const handleClickCalcBtn = () => {
    if (validate()) {
      calculateScore();
    }
  }

  const handleFocusCbox = () => {
    document.getElementById("haveMathPhysics").focus();
  }

  const handleFocusBtn = () => {
    document.getElementById("calcBtn").focus();
  }

  const calculateScore = () => {
    const jsonParams = {};
    chosenFields.includes("maturity") ? jsonParams.maturity = formFields.maturity : null;
    chosenFields.includes("psycho") ? jsonParams.psycho = formFields.psycho : null;
    chosenFields.includes("adapter") ? jsonParams.adapter = formFields.adapter : null;
    checkBox ? jsonParams.reali10 = 1 : 0;
    buildJsonAndCallLastScore(jsonParams);
  }

  return (
    <div className={`custom-calc ${showCustomCalcOnMob ? "" : "d-none d-md-block"}`}>
      {Utils.isMobile()  &&
      <button 
        className="close-btn" 
        data-dismiss="modal" 
        id="close-modal-btn" 
        onClick={handleClickCalcAgain} 
        aria-label={labels.closeModal}>
        <img src={closeBtn} className="close-img" alt={labels.closeModal} />
      </button>
      }
      <h3 className="calc-explanation d-md-none" tabIndex="0" aria-label={labels[`${unchosenField}CalcTitle`]}>{labels[`${unchosenField}CalcTitle`]}</h3>
      <div className="calc-fields-wrapper">
        <CalculatorField 
          fieldName={chosenFields?.[0]} 
          handleChange={handleChange} 
          fieldValue={formFields[chosenFields?.[0]]} 
          title={labels[chosenFields?.[0]]} 
          errMsg={labels[`${chosenFields?.[0]}Error`]}
          fieldInvalid={checkIfInvalid(chosenFields?.[0])} 
        />
        {checkIfInvalid(chosenFields?.[0]) ? ( 
          <span aria-label={labels.maturityError} tabIndex="0" className="text-danger">{labels.maturityError}</span> 
        ) : null}
        
        <CalculatorField 
          fieldName={chosenFields?.[1]} 
          handleChange={handleChange} 
          fieldValue={formFields[chosenFields?.[1]]}  
          title={labels[chosenFields?.[1]]} 
          errMsg={labels[`${chosenFields?.[1]}Error`]}
          fieldInvalid={checkIfInvalid(chosenFields?.[1])} 
          handleBlur={handleFocusCbox}
        />
        
        {checkIfInvalid(chosenFields?.[1]) && formFields[chosenFields?.[1]] !== "" ? ( 
          <span aria-label={labels.psychoError} tabIndex="0" className="text-danger psycho-text-danger">{labels.psychoError}</span> 
        ) : null}
      </div>
      <Button
        id="calcBtn"
        className="calc-btn d-none d-md-inline-block" 
        variant="dark"
        onClick={() => handleClickCalcBtn()}
        aria-label={labels.calculate}
      > 
        {labels.calculate}
      </Button>
      {showResult && (
        <CalcResult 
          score={formFields[unchosenField]} 
          unchosenField={unchosenField} 
          labels={labels} 
          display="d-none d-md-inline-block" 
          aria-live="polite" 
        />
      )}
      {!chosenFields.includes("adapter") &&
        <div className="have-math-physics">
          <Form.Group controlId="formMathPhysics">
            <Form.Check 
              type="checkbox" 
              defaultChecked={checkBox} 
              label={labels.haveMathPhysics} 
              id="haveMathPhysics" 
              aria-label={labels.haveMathPhysics} 
              onChange={(e) => { e.target.checked ? setCheckBox(true) : setCheckBox(false); }}
              onBlur={handleFocusBtn}
            />
          </Form.Group>
        </div>
      }
      <Button
        className={`calc-btn d-md-none`} 
        variant="dark"
        onClick={() => handleClickCalcBtn()}
        aria-label={labels.calculate}
      > 
        {labels.calculate}
      </Button>
      {showResult && (
        <>
          <CalcResult 
            score={formFields[unchosenField]} 
            unchosenField={unchosenField} 
            labels={labels} 
            display="d-md-none" 
            aria-live="polite" 
          />
          {!chosenFields.includes("adapter") && (
            <MarkAdapter 
              labels={labels} 
              MatchScores={scoresData?.getLastScore?.body} 
              aria-live="polite" 
            />
          )}
          <button 
            className="calc-again" 
            onClick={handleClickCalcAgain} 
            aria-label={labels.calcAgain}>
            {labels.calcAgain}
          </button>
          <img 
            src={leftArrow} 
            alt={labels.recalculate} 
            tabIndex="0" 
            className="arrow-img" 
          />
        </>
      )}
    </div>
  )
}
